import { render } from "./lists_edit.vue?vue&type=template&id=b36e4970"
import script from "./lists_edit.js?vue&type=script&lang=js"
export * from "./lists_edit.js?vue&type=script&lang=js"

import "./lists_edit.vue?vue&type=style&index=0&id=b36e4970&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__